<a href="/">
    <img
        *ngIf="!appSession.tenant || !appSession.tenant.HasLogo()"
        src="/assets/common/images/app-logo-on-dark.png"
        alt="logo"
        class="h-25px h-lg-25px"
    />
    <img
        *ngIf="appSession.tenant && appSession.tenant.HasLogo()"
        [src]="
            remoteServiceBaseUrl +
            '/TenantCustomization/GetTenantLogo?skin=dark' +
            '&tenantId=' +
            appSession.tenant.id
        "
        alt="logo"
        class="h-25px h-lg-25px"
    />
</a>
